import { render } from "./Main.vue?vue&type=template&id=4bb18f76&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=4bb18f76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb18f76"],['__file',"src/views/main/Main.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bb18f76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bb18f76', __exports__)) {
    api.reload('4bb18f76', __exports__)
  }
  
  module.hot.accept("./Main.vue?vue&type=template&id=4bb18f76&scoped=true", () => {
    api.rerender('4bb18f76', render)
  })

}


export default __exports__